export type Shift = {
    shiftId: string;
    name: string;
    isDefault: boolean;

    daysOfWeek: string;
    start: number;
    end: number;
};

export enum WeekDay {
    MON = 'MON',
    TUE = 'TUE',
    WED = 'WED',
    THU = 'THU',
    FRI = 'FRI',
    SAT = 'SAT',
    SUN = 'SUN',
}

export const WEEK_DAYS: WeekDay[] = [
    WeekDay.MON,
    WeekDay.TUE,
    WeekDay.WED,
    WeekDay.THU,
    WeekDay.FRI,
    WeekDay.SAT,
    WeekDay.SUN,
];

export type GetShiftPayload = { shiftId: string };

export type DeleteShiftPayload = { shiftId: string };

export type PostShiftPayload = {
    brandId: number;
    restaurantId: number;
    name: string;
    daysOfWeek: string;
    start: number;
    end: number;
    endsTomorrow: boolean;
    color: string;
    isEnabled: boolean;
    isDefault: boolean;
};

export type PutShiftPayload = {
    shiftId: string;
    name: string;
    daysOfWeek: string;
    start: number;
    end: number;
    endsTomorrow: boolean;
    color: string;
    isEnabled: boolean;
};
